import './AppNavBar.scss';
import { Dispatch, SetStateAction } from 'react';
import { LANGUAGE } from '../../../constants/common';
import { NavLink, NavigateFunction, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../../providers/AuthProvider';
import { useTranslation } from 'react-i18next';
import HistoryIcon from '@mui/icons-material/History';
import logo from '../../../assets/images/logo.png';
import PersonIcon from '@mui/icons-material/Person';
import RedeemIcon from '@mui/icons-material/Redeem';

interface Props {
    activeMenuIndex: number;
    navigate: NavigateFunction;
    setActiveMenuIndex: Dispatch<SetStateAction<number>>;
}

const AppNavBar = ({activeMenuIndex, navigate, setActiveMenuIndex}: Props) => {
    const authContext = useAuthProvider();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const appPages = ['history'];
    const HISTORY_PAGE_PATH = `/${i18n.language}/history`;
    const REQUEST_PAGE_PATH = `/${i18n.language}`;

    const getPagePath = (pathArray,appPages) => {
        let pagePath = '';
        pagePath = pathArray.find(path => appPages.includes(path));
        return pagePath;
    };

    const handleOnClickLanguage = (lang: string) => {
        const pathArray = location.pathname.split('/');
        const pagePath = getPagePath(pathArray, appPages);
        const language = lang === LANGUAGE.en ? LANGUAGE.fr : LANGUAGE.en;
        pagePath ? navigate(`/${language}/${pagePath}`) : navigate(`/${language}`);
    };

    const handleOnClickHistoryPage = () => {
        setActiveMenuIndex(1);
        sessionStorage.clear();
        navigate(`/${i18n.language}/history`);
    };

    const handleOnClickMenuToggle = () => {
        const page = document.getElementById('back-drop-filter');
        if(page) page.classList.toggle('back-drop-filter--active');
    };

    const handleOnClickRequestPage = () => {
        setActiveMenuIndex(0);
        navigate(`/${i18n.language}`);
    };

    return (
        <header className="nav-bar-header">
            <div className="c-nav-bar">
                <div className="c-logo">
                    <div className="c-menuToggle-main">
                        <div className="c-menuToggle">
                            <input type="checkbox" onClick={() => handleOnClickMenuToggle()}/>
                            <span></span>
                            <span></span>
                            <span></span>
                            <ul className="c-menu">
                                <li className="c-menu--logo">
                                    <img className="logo__img" src={logo} alt="logo" />{t('appName')}
                                </li>
                                <a href={REQUEST_PAGE_PATH}><li className="c-menu-item"><RedeemIcon className="item-icon" />{t('navMenu.request')}</li></a>
                                <a href={HISTORY_PAGE_PATH}><li className="c-menu-item"><HistoryIcon className="item-icon" />{t('navMenu.history')}</li></a>
                                <li className="c-menu-item" onClick={() => handleOnClickLanguage(i18n.language)}>{t('labels.language')}</li>
                                <li className="c-menu-item" onClick={() => authContext.logout()}> {t('buttons.logout')} </li>
                            </ul>
                        </div>
                    </div>
                    <img className="logo__img" src={logo} alt="logo" />
                    <span className="logo__title">{t('appName')}</span>                    
                </div>
                <div className="c-nav-menu">
                    <nav>
                        <ul className="nav-menu">
                            <li 
                                className={`nav-menu__item nav-menu__item--center ${activeMenuIndex === 0 ? 'border-bottom--selected' : ''}`}
                                id="nav-menu__item--request"
                                onClick={() => handleOnClickRequestPage()}
                            >
                                <NavLink to="#"><RedeemIcon className="item-icon" /></NavLink>
                                <p className="item__text">{t('navMenu.request')}</p>
                            </li>
                            <li 
                                className={`nav-menu__item nav-menu__item--center ${activeMenuIndex === 1 ? 'border-bottom--selected' : ''}`}
                                id="nav-menu__item--history"
                                onClick={() => handleOnClickHistoryPage()}
                            >
                                <NavLink to="#"><HistoryIcon className="item-icon" /></NavLink>
                                <p className="item__text">{t('navMenu.history')}</p>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div>                
                    <nav>
                        <ul className="nav-menu">
                            <li className="nav-menu__item">
                                <p className="item__lang" onClick={() => handleOnClickLanguage(i18n.language)}>{t('labels.language')}</p>
                            </li>
                            <li className="nav-menu__item">
                                {authContext.user.name && (
                                    <p className="item__text">
                                        {`${authContext.user.name.split(' ')[0]} ${authContext.user.name.split(' ')[authContext.user.name.split(' ').length-1][0]}.`}
                                    </p>
                                )}
                                <NavLink to="#"><PersonIcon className="icon-person" /></NavLink>
                                <div
                                    className="item__submenu"
                                    onClick={() => authContext.logout()}
                                    style={{marginLeft: i18n.language === LANGUAGE.fr ? '0.9rem' : '4rem' }}
                                >
                                    {t('buttons.logout')}
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default AppNavBar;
